import React, {useState, useMemo} from 'react'
import {InputGroup, FormControl, Button} from 'react-bootstrap'
import CRUDTable from '../../../components/table/CRUDTable'
import {StudentTripAPIData} from '../../ts/trip'
import ModalWithForm from '../../../components/ModalWithForm'
import AddStudentToTrip from './AddStudentToTrip'
import DeleteButton from '../../../components/DeleteButton'
import toast from 'react-hot-toast'
import {Student} from '../student/type'
import {removeStudentFromTrip} from './api'

interface StudentsInTripTableProps {
  studentData: StudentTripAPIData[]
  fieldsToLableMap: {}
  tripId: string | number
  refetchStudentData: () => Promise<any>
}

const StudentsInTripTable: React.FC<StudentsInTripTableProps> = ({
  studentData,
  fieldsToLableMap,
  tripId,
  refetchStudentData,
}) => {
  const [searchInput, setSearchInput] = useState('')

  const filteredData = useMemo(
    () =>
      studentData.filter(
        (item) =>
          item.student_name.toLowerCase().includes(searchInput.toLowerCase()) ||
          (item.regID && item.regID.toLowerCase().includes(searchInput.toLowerCase()))
      ),
    [studentData, searchInput]
  )

  return (
    <div>
      <div className="d-flex align-items-center border-bottom pb-4">
        <InputGroup className="px-10" style={{width: '80%'}} size="sm" aria-describedby="search">
          <InputGroup.Text id="search">Search</InputGroup.Text>
          <FormControl
            placeholder="Search by Student name or Registration Id"
            aria-label="Search"
            aria-describedby="search"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </InputGroup>
        <div style={{width: '20%'}}>
          <ModalWithForm
            Form={AddStudentToTrip}
            initialValues={{existingStudentsInTrip: studentData, trip_id: tripId}}
            modalTitle={'Add Student to Trip'}
            modalAttrs={{size: 'sm'}}
            onSubmit={refetchStudentData}
          >
            <Button size="sm">Add Student to Trip</Button>
          </ModalWithForm>
        </div>
      </div>
      <div style={{fontSize: '0.9rem'}}>
        <CRUDTable
          formSize="sm"
          isSearchable={false}
          fieldToLabelMap={fieldsToLableMap}
          data={filteredData || []}
          cellModifier={{
            remove: ({row}: {row: {original: Student}}) => (
              <DeleteButton
                onDelete={async () => {
                  const toastId = toast.loading('Removing Please wait...')
                  try {
                    const response = await removeStudentFromTrip({
                      student_id: row.original.student_id,
                      trip_id: tripId,
                    })
                    if (response?.status === false && response?.message) {
                      toast.error(response.message, {id: toastId})
                      return null
                    }
                    await refetchStudentData()
                    toast.success('Removed student from trip Successfully', {id: toastId})
                  } catch (error) {
                    toast.error('Something went wrong, please try again later', {id: toastId})
                  }
                }}
              />
            ),
          }}
        />
      </div>
    </div>
  )
}

export default StudentsInTripTable
